import React from 'react'
import './index.scss'

interface ISkeletonText {
  height: number
  lineHeight?: number
  lineGap?: number
  minWidthPercent?: number
  maxWidthPercent?: number
}

const SkeletonText: React.FC<ISkeletonText> = ({
  height,
  lineHeight = 16,
  lineGap = 8,
  minWidthPercent = 60,
  maxWidthPercent = 100,
}) => {
  const totalLineSpace = lineHeight + lineGap
  const lineCount = Math.floor(height / totalLineSpace)

  const lines = Array.from({ length: lineCount }, (_, i) => {
    const widthPercent = Math.floor(Math.random() * (maxWidthPercent - minWidthPercent + 1)) + minWidthPercent

    return (
      <div
        key={i}
        className="text-skeleton-line"
        style={{
          height: `${lineHeight}px`,
          width: `${widthPercent}%`,
          marginBottom: i < lineCount - 1 ? `${lineGap}px` : 0,
        }}
      />
    )
  })

  return <div>{lines}</div>
}

export default SkeletonText
